import { render, staticRenderFns } from "./AppProduct.vue?vue&type=template&id=e1b1e952&scoped=true&"
import script from "./AppProduct.vue?vue&type=script&lang=js&"
export * from "./AppProduct.vue?vue&type=script&lang=js&"
import style0 from "./AppProduct.vue?vue&type=style&index=0&id=e1b1e952&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1b1e952",
  null
  
)

export default component.exports